import { generateTestId } from "@client-shared";
import { CheckCircle, Clock, LucideIcon, Package, XCircle } from "lucide-react";

export const setOrdersStatsTestId = (identifier: string): string =>
  generateTestId("OrdersStats", identifier);

export interface StatConfig {
  nameKey: string;
  value: string;
  icon: LucideIcon;
  iconBg: string;
  iconColor: string;
}

export const statsConfig: StatConfig[] = [
  {
    nameKey: "views.ordersStats.totalOrders",
    value: "1,847",
    icon: Package,
    iconBg: "bg-blue-100 dark:bg-blue-950",
    iconColor: "text-blue-700 dark:text-blue-400",
  },
  {
    nameKey: "views.ordersStats.processing",
    value: "124",
    icon: Clock,
    iconBg: "bg-amber-100 dark:bg-amber-950",
    iconColor: "text-amber-700 dark:text-amber-400",
  },
  {
    nameKey: "views.ordersStats.completed",
    value: "1,689",
    icon: CheckCircle,
    iconBg: "bg-primary/10",
    iconColor: "text-primary",
  },
  {
    nameKey: "views.ordersStats.cancelled",
    value: "34",
    icon: XCircle,
    iconBg: "bg-red-100 dark:bg-red-950",
    iconColor: "text-red-700 dark:text-red-400",
  },
];
